<template>
  <img :src="require(`img/icons/icon-${icon}.svg`)"
       :alt="icon"
       :height="height"
       :width="width"
  >
</template>

<script>
  export default {
    name: 'GlSvgIcon',
    props: {
      icon: {
        type: String,
        required: true,
      },
      height: {
        type: String,
        required: false,
        default: '24',
      },
      width: {
        type: String,
        required: false,
        default: '24',
      },
    },
  }
</script>

<style lang="scss" scoped>
  .svgIcon {
    align-items: center;
    display: inline-flex;
    justify-content: center;
  }
</style>
